import { JSX } from 'react';
import { HighlightedQuote } from '@ahc-digital/component-library';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { CreateHighlightedQuoteModel } from './C45HighlightedQuote.service';
import { C45HighlightedQuoteProps } from './C45HighlightedQuote.types';

const Default = (props?: C45HighlightedQuoteProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return (
    <HighlightedQuote
      id={props?.params?.AnchorLinkTargetName}
      className={translationClasses(props?.params)}
      data-component={marketingRenderingName}
      {...CreateHighlightedQuoteModel(props)}
    />
  );
};

export default checkDatasourceForRendering<C45HighlightedQuoteProps>(Default);
